<div id="header">
  <div class="header">
    <div class="header-box clearfix">
      <div class="logo">
        <a href="http://www.opensourcesoundscapes.org/">
          <img src="assets/images/logo-small.png" alt="Hush City">
        </a>
      </div>
      <div id="icon-menu" [ngClass]="{ 'active' : isActive === true }" class="icon-menu" (click)="toggleMenu()">
        <span></span>
      </div>
      <div id="hmenu" [ngClass]="{ 'active' : isActive === true }" class="hmenu float-right clearfix">
        <ul class="list-view-type clearfix">
          <li>
            <a href="http://www.opensourcesoundscapes.org/">HOME</a>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/about/">ABOUT</a>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/hush-city/">HUSH CITY APP</a>
          </li>
          <li>
            <a routerLink="/view-area" routerLinkActive="active" (click)="resetView()">HUSH CITY MAP</a>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/hush-city-ambassadors/">HUSH CITY AMBASSADORS</a>
          </li>
          <li>
            <a routerLink="">PROJECTS</a>
            <span (click)="toggleSubMenu($event)"></span>
            <ul>
              <li>
                <a href="http://www.opensourcesoundscapes.org/research/beyond-the-noise/">Beyond the Noise (2016-2018)</a>
              </li>
              <li>
                <a href="http://www.opensourcesoundscapes.org/research/hush-city-mobile-lab/">Hush City Mobile Lab (2018-2020)</a>
              </li>
              <li>
                <a href="http://www.opensourcesoundscapes.org/research/sound-and-the-healthy-city/">Sound &amp; the Healthy City (2018-on)</a>
              </li>
            </ul>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/publications/">RESOURCES</a>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/blog/">BLOG</a>
          </li>
          <li>
            <a href="http://www.opensourcesoundscapes.org/contact/">CONTACT</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>